import { Club, ClubMembership, ClubMember, ChatMessage, MembershipStatus } from '../types/clubs';
import { COUNTRIES_WITH_CITIES } from './countriesAndCities';

// Mock current user
export const CURRENT_USER_ID = 'user-1';

// Mock clubs
export const mockClubs: Club[] = [
  {
    id: 'club-1',
    name: 'Bangalore Tech Entrepreneurs',
    category: 'Technology',
    city: 'Bangalore',
    description: 'A community for tech entrepreneurs in Bangalore to connect, share ideas, and collaborate on innovative projects.',
    coverPhotoUrl: 'https://en.sangritimes.com/uploads/images/2023/10/image_750x_652148227a447.jpg',
    createdBy: 'user-2',
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // 30 days ago
    memberCount: 45,
    chatEnabled: true,
  },
  {
    id: 'club-2',
    name: 'Mumbai Finance Professionals',
    category: 'Finance',
    city: 'Mumbai',
    description: 'Connect with finance professionals in Mumbai. Discuss market trends, investment strategies, and career opportunities.',
    coverPhotoUrl: 'https://www.bni.com/wp-content/uploads/2025/02/what-is-bni-yt.jpg',
    createdBy: 'user-1', // Current user is admin
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000), // 15 days ago
    memberCount: 32,
    chatEnabled: true,
  },
  {
    id: 'club-3',
    name: 'Delhi Marketing Network',
    category: 'Marketing',
    city: 'Delhi',
    description: 'Marketing professionals in Delhi sharing best practices, case studies, and networking opportunities.',
    coverPhotoUrl: 'https://club.bnigalicia.com/resources/img/logo.png',
    createdBy: 'user-3',
    createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000), // 20 days ago
    memberCount: 28,
    chatEnabled: false,
  },
  {
    id: 'club-4',
    name: 'Hyderabad Startup Founders',
    category: 'Startups',
    city: 'Hyderabad',
    description: 'Startup founders in Hyderabad supporting each other through the entrepreneurial journey.',
    coverPhotoUrl: 'https://en.sangritimes.com/uploads/images/2023/10/image_750x_652148227a447.jpg',
    createdBy: 'user-4',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), // 10 days ago
    memberCount: 18,
    chatEnabled: true,
  },
  {
    id: 'club-5',
    name: 'Pune Product Managers',
    category: 'Product Management',
    city: 'Pune',
    description: 'Product managers in Pune discussing product strategy, user research, and product development.',
    coverPhotoUrl: 'https://www.bni.com/wp-content/uploads/2025/02/what-is-bni-yt.jpg',
    createdBy: 'user-5',
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    memberCount: 22,
    chatEnabled: true,
  },
  {
    id: 'club-6',
    name: 'Chennai Software Developers',
    category: 'Technology',
    city: 'Chennai',
    description: 'Software developers in Chennai sharing knowledge, code reviews, and tech discussions.',
    coverPhotoUrl: 'https://club.bnigalicia.com/resources/img/logo.png',
    createdBy: 'user-6',
    createdAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000), // 25 days ago
    memberCount: 56,
    chatEnabled: true,
  },
];

// Mock memberships
export const mockMemberships: ClubMembership[] = [
  {
    id: 'membership-1',
    clubId: 'club-1',
    userId: 'user-1', // Current user is member
    role: 'member',
    status: 'approved',
    createdAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000),
  },
  {
    id: 'membership-2',
    clubId: 'club-2',
    userId: 'user-1', // Current user is admin
    role: 'admin',
    status: 'approved',
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000),
  },
  {
    id: 'membership-3',
    clubId: 'club-4',
    userId: 'user-1', // Current user has pending request
    role: 'member',
    status: 'pending',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
  },
];

// Mock club members (for detail view)
export const mockClubMembers: Record<string, ClubMember[]> = {
  'club-1': [
    {
      id: 'user-2',
      name: 'Rajesh Kumar',
      profession: 'Software Engineer',
      city: 'Bangalore',
      role: 'admin',
    },
    {
      id: 'user-1',
      name: 'John Doe',
      profession: 'Product Manager',
      city: 'Bangalore',
      role: 'member',
    },
    {
      id: 'user-7',
      name: 'Priya Sharma',
      profession: 'UX Designer',
      city: 'Bangalore',
      role: 'member',
    },
    {
      id: 'user-8',
      name: 'Amit Patel',
      profession: 'Data Scientist',
      city: 'Bangalore',
      role: 'member',
    },
  ],
  'club-2': [
    {
      id: 'user-1',
      name: 'John Doe',
      profession: 'Financial Analyst',
      city: 'Mumbai',
      role: 'admin',
    },
    {
      id: 'user-9',
      name: 'Sneha Reddy',
      profession: 'Investment Banker',
      city: 'Mumbai',
      role: 'member',
    },
    {
      id: 'user-10',
      name: 'Vikram Singh',
      profession: 'Chartered Accountant',
      city: 'Mumbai',
      role: 'member',
    },
  ],
};

// Mock chat messages
export const mockChatMessages: Record<string, ChatMessage[]> = {
  'club-1': [
    {
      id: 'msg-1',
      clubId: 'club-1',
      userId: 'user-2',
      userName: 'Rajesh Kumar',
      message: 'Welcome everyone to Bangalore Tech Entrepreneurs!',
      createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
    },
    {
      id: 'msg-2',
      clubId: 'club-1',
      userId: 'user-1',
      userName: 'John Doe',
      message: 'Thanks for creating this group!',
      createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000),
    },
    {
      id: 'msg-3',
      clubId: 'club-1',
      userId: 'user-7',
      userName: 'Priya Sharma',
      message: 'Looking forward to connecting with everyone here.',
      createdAt: new Date(Date.now() - 30 * 60 * 1000),
    },
  ],
  'club-2': [
    {
      id: 'msg-4',
      clubId: 'club-2',
      userId: 'user-1',
      userName: 'John Doe',
      message: 'Welcome to Mumbai Finance Professionals. Feel free to share your thoughts!',
      createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000),
    },
  ],
};

// Pending join requests (for admin view)
export const mockPendingRequests: Record<string, ClubMember[]> = {
  'club-2': [
    {
      id: 'user-11',
      name: 'Rahul Verma',
      profession: 'Financial Advisor',
      city: 'Mumbai',
      role: 'member',
    },
    {
      id: 'user-12',
      name: 'Anita Desai',
      profession: 'Portfolio Manager',
      city: 'Mumbai',
      role: 'member',
    },
  ],
};

// Helper functions
export const getClubById = (id: string): Club | undefined => {
  return mockClubs.find(club => club.id === id);
};

export const getUserMemberships = (userId: string): ClubMembership[] => {
  return mockMemberships.filter(m => m.userId === userId);
};

export const getUserClubs = (userId: string): Club[] => {
  const membershipClubIds = getUserMemberships(userId).map(m => m.clubId);
  return mockClubs.filter(club => membershipClubIds.includes(club.id));
};

export const getMembershipStatus = (clubId: string, userId: string): MembershipStatus => {
  const membership = mockMemberships.find(m => m.clubId === clubId && m.userId === userId);
  if (!membership) return 'not-member';
  return membership.status === 'approved' ? 'joined' : 'pending';
};

export const isClubAdmin = (clubId: string, userId: string): boolean => {
  const membership = mockMemberships.find(m => m.clubId === clubId && m.userId === userId);
  return membership?.role === 'admin' && membership?.status === 'approved';
};

export const getClubMembers = (clubId: string): ClubMember[] => {
  return mockClubMembers[clubId] || [];
};

export const getChatMessages = (clubId: string): ChatMessage[] => {
  return mockChatMessages[clubId] || [];
};

export const getPendingRequests = (clubId: string): ClubMember[] => {
  return mockPendingRequests[clubId] || [];
};

export const getDiscoverClubs = (userId: string): Club[] => {
  const userClubIds = getUserClubs(userId).map(c => c.id);
  return mockClubs.filter(club => !userClubIds.includes(club.id));
};

// Format relative time
export const getRelativeTime = (date: Date): string => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
};

// Mock categories and cities for filters
export const CLUB_CATEGORIES = [
  'Technology',
  'Finance',
  'Marketing',
  'Startups',
  'Business',
  'NGO',
  'Product Management',
  'Design',
  'Sales',
  'HR',
  'Operations',
];

// Use the same comprehensive city list from onboarding
const indiaCities = COUNTRIES_WITH_CITIES.find(c => c.name === 'India')?.cities || [];
export const CLUB_CITIES = indiaCities;
